import Box from "../../../../components/Box";
import { GetMeetingByIdResponseAntrepoOffer } from "../../../../models/response/meeting/GetMeetingByIdResponse";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";

interface Props {
    antrepoOffersRef: any
    antrepoOffers: GetMeetingByIdResponseAntrepoOffer[]
}

const AntrepoOffers = ({
    antrepoOffersRef,
    antrepoOffers
}: Props) => {
    return (
        <div className='containerPart' ref={antrepoOffersRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Bağlı Teklifler</h4>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th>Teklif Ref No</th>
                                            <th>Teklif Durumu</th>
                                            <th>Teklif Başlangıç Tarihi</th>
                                            <th>Teklif Bitiş Tarihi</th>
                                            <th>İşlem Tarihi</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            antrepoOffers.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            antrepoOffers.map((item, index) =>
                                                <tr>
                                                    <td><a onClick={() => window.open(window.location.href.split('=')[0].replace('meeting', 'antrepooffer') + "=" + item.antrepoOfferId, "_blank")} href='javascript:;'>{item.refNo}</a></td>
                                                    <td>
                                                        <Box>
                                                            <Box bg={item.offerStatusAdditionalValue1 == '1' ? '#f7b924' : item.offerStatusAdditionalValue1 == '2' ? '#3ac47d' : item.offerStatusAdditionalValue1 == '3' ? '#16aaff' : '#d92550'} pt='3px' pb='3px' pl='10px' pr='10px' borderRadius='99px' alignSelf='flex-start' className='text-white'>
                                                                {item.offerStatusName}
                                                            </Box>
                                                        </Box>
                                                    </td>
                                                    <td>{item.startDate}</td>
                                                    <td>{item.endDate}</td>
                                                    <td>{item.offerStatusChangeDate}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default AntrepoOffers;